import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

// 🔥 helper
const getCssVar = (variable: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

const UserBarChart = ({ data }: any) => {
  const chartData = useMemo(
    () => [
      { name: "Users", value: data?.users || 0 },
      { name: "Providers", value: data?.providers || 0 },
    ],
    [data]
  );

  const colors = [
    getCssVar("--primary-main"),
    getCssVar("--blue"),
  ];

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={chartData}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />

        <Bar dataKey="value" radius={[6, 6, 0, 0]}>
          {chartData.map((_, index) => (
            <Cell key={index} fill={colors[index]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UserBarChart;